import { render, staticRenderFns } from "./IcDot.vue?vue&type=template&id=21476b34&scoped=true"
import script from "./IcDot.vue?vue&type=script&lang=js"
export * from "./IcDot.vue?vue&type=script&lang=js"
import style0 from "./IcDot.vue?vue&type=style&index=0&id=21476b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21476b34",
  null
  
)

export default component.exports